import React from "react";
import { useState } from "react";
import Img1 from "./Images/Mobile.webp";
import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CountUp from "react-countup";
import Acquisition from "./Images/Cost 1002.png";
import Interactive from "./Images/Intractive 1002.png";
import Opening from "./Images/Opening Rate 1001.png";
import WhatsApp from "./Images/Users1001.png";
import { useInView } from "react-intersection-observer";
import doodle from "./Images/bg.png";
import CardMedia from "@mui/material/CardMedia";

// Data for the cards
const cardData = [
  {
    img: Interactive,
    countEnd: 800,
    duration: 6,
    suffix: "msec",
    description: "Interactive time",
  },
  {
    img: Acquisition,
    countEnd: 30,
    duration: 4,
    prefix: "₹",
    description: "Acquisition cost",
  },
  {
    img: Opening,
    countEnd: 60,
    duration: 2,
    suffix: "%",
    decimals: 2,
    description: "Opening rate",
  },
  {
    img: WhatsApp,
    countEnd: 2.78,
    duration: 3,
    suffix: " Bn+",
    description: "WhatsApp users",
  },
];

// Styled components
const IconBox = styled(Box)(({ bgcolor, theme }) => ({
  backgroundColor: "white",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "70%",
  height: "100%",
  position: "absolute",
  top: -10,
  clipPath: "polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%)",
}));

const MobileSection1 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [Img1, Img1, Img1]; // Using Img1 for the slider
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.5 });

  // Swipe logic
  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    const swipeDistance = touchEndX - touchStartX;
    if (swipeDistance < -50) {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    } else if (swipeDistance > 50) {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "55vh",
      }}
    >
      <Box
        sx={{
          py: 0,
          textAlign: "center",
          width: { xl: "74%", lg: "79%", md: "90%", sm: "95%", xs: "95%" },
          // border: "1px solid blue",
          marginTop: "-6px"
        }}
      >
        {/* Image Slider */}
        <Stack>
          <Stack
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            sx={{
              // border: "1px solid gray",
              backgroundSize: "contain",
              borderRadius: "8px",
              height: "50vh",
              position: "relative",
              overflow: "hidden",
              mb: 4,
              backgroundImage: `url(${doodle})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundAttachment: "fixed",
            }}
          >
            <Stack
              direction="row"
              sx={{
                width: `${images.length * 100}%`,
                height: "100%",
                transform: `translateX(-${currentIndex * (100 / images.length)}%)`,
                transition: "transform 0.3s ease-in-out",
              }}
            >
              {images.map((image, index) => (
                <CardMedia
                  key={index}
                  component="img"
                  image={image}
                  alt={`Slide ${index}`}
                  sx={{
                    width: `${100 / images.length}%`,
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ))}
            </Stack>

            {/* Slider dots */}
            <Stack
              direction="row"
              spacing={1}
              sx={{
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              {images.map((_, index) => (
                <Stack
                  key={index}
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: currentIndex === index ? "rgb(5 78 146)" : "#7A7A7A",
                  }}
                />
              ))}
            </Stack>
          </Stack>
        </Stack>

        {/* Card Stats */}
        <Grid
          container
          rowGap={1.2}

          justifyContent="center"
          alignItems="center"

          mb={4}
          ref={ref}
          sx={{
            mt:-1.2,
            // border: "1px solid red"
          }}
          spacing={2.4}
        >
          {cardData.map((card, index) => (
            <Grid
              item
              xs={6}
              sm={3}
              key={index}
              display="flex"
              justifyContent="center"
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(107, 107, 107, 0.1)",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: { xs: "155px", lg: "230px", xl: "250px" },
                  //  maxWidth: { xs: "150px", lg: "210px", xl: "230px" },
                  aspectRatio: "1 / 1",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                  // backgroundImage: `url(${Img1})`, // Img1 as card background
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* icon part */}
                <Box
                  sx={{
                    backgroundColor:
                      index === 0
                        ? "rgb(180, 210, 245)"
                        : index === 1
                          ? "rgb(245, 200, 180)"
                          : index === 2
                            ? "rgb(180, 220, 190)"
                            : "rgb(200, 180, 240)",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: { xs: "80px", lg: "120px" },
                    position: "relative",
                  }}
                >
                  <IconBox
                    bgcolor={
                      index === 0
                        ? "rgb(180, 210, 245)"
                        : index === 1
                          ? "rgb(245, 200, 180)"
                          : index === 2
                            ? "rgb(180, 220, 190)"
                            : "rgb(200, 180, 240)"
                    }
                  >
                    <img
                      src={card.img}
                      alt={card.description}
                      style={{
                        width: 40,
                        height: 40,
                        objectFit: "contain",
                      }}
                    />
                  </IconBox>
                </Box>
                {/* text parts */}
                <Box
                  sx={{
                    flexGrow: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white to make text readable over Img1
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#054E92",
                      fontSize: { xs: "1.2rem", md: "1.5rem", lg: "2rem" },
                    }}
                  >
                    <CountUp
                      start={inView ? 0 : card.countEnd}
                      end={card.countEnd}
                      duration={card.duration}
                      suffix={card.suffix || ""}
                      prefix={card.prefix || ""}
                      decimals={card.decimals || 0}
                    />
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                      color: "#054E92",
                      opacity: 0.8,
                    }}
                  >
                    {card.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default MobileSection1;